import React from 'react';
import classnames from 'classnames';
import InputLabel from '../InputLabel';
import { InputLabelProps } from '../InputLabel/InputLabel';
import { getInputClassForValidationState } from '../ValidationMessage/helper';
import { ValidationState } from '../ValidationMessage/ValidationMessage';
import { TypeProps } from '../Input/Input';

export interface InputWrapperProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  disableInputStyle?: boolean;
  disableValidationStyle?: boolean;
  type?: TypeProps | 'textarea';
  validationState?: ValidationState;
  fullWidth?: boolean;
  inputLabelProps?: InputLabelProps;
  id?: string;
  isRequired?: boolean;
  name?: string;
  label?: string;
  isInputSet?: boolean;
}

const InputWrapper: React.FunctionComponent<InputWrapperProps> = ({
  className = '',
  disableInputStyle = false,
  disableValidationStyle = false,
  type = 'text',
  validationState,
  fullWidth = false,
  inputLabelProps,
  id,
  isRequired,
  name,
  label,
  children,
  isInputSet = false,
  ...otherProps
}) => (
  <div
    className={classnames(
      className,
      {
        'input--date': type === 'date',
        input: !disableInputStyle,
        'w-100': fullWidth
      },
      !isInputSet &&
        !disableValidationStyle &&
        getInputClassForValidationState(validationState)
    )}
    {...otherProps}
  >
    {label && (
      <InputLabel
        htmlFor={id || name}
        aria-labelledby={id || name}
        isRequired={isRequired}
        {...inputLabelProps}
      >
        {label}
      </InputLabel>
    )}
    <div
      className={classnames(
        'input__row',
        'flex-column',
        isInputSet &&
          !disableValidationStyle &&
          getInputClassForValidationState(validationState)
      )}
    >
      {children}
    </div>
  </div>
);

export default InputWrapper;
